import Episode from "../models/episode";
import { Akshay, Trisha, Riddhi, Parth, Bhaskar, MAD, ChhotaBhai, InspectorRathore } from "./character_data";


// Akshay Episodes
const AkshayQuitsJob: Episode = {
    name: "Gharwali Baharwala",
    code: "1P01",
    featuring: [Akshay, Trisha],
    plot: "Akshay, on Parth's insistence, pretends to work from home while skipping work. Meanwhile, Trisha works a part-time job under the pretence of attending her friend's brother's wedding rituals.",
    // link: "https://youtu.be/uGefvWvUZEc"
}

const AkshayRace: Episode = {
    name: "Bhaag Akshay Bhaag",
    code: "1P06",
    featuring: [Akshay, InspectorRathore, ChhotaBhai],
    plot: "On provocation, Trisha signs up Akshay and herself for a couple's race. Trisha and Riddhi rigorously train Akshay for the race. Meanwhile, Inspector Rathore learns that Chhota Bhai is up to something."
}

// Trisha Episodes

const TrishaRevolt: Episode = {
    name: "Kya Kool Hai Trisha",
    code: "1P03",
    featuring: [Trisha, Riddhi, Parth],
    plot: "Trisha's colleagues start to hate her when she cancels Thanksgiving's day off because it is an American holiday. She struggles to find a way to win them back. Meanwhile, Parth coerces Riddhi into running a 'Gamer Girl' channel where he plays but she is the face."
}


const TrishaHacker: Episode = {
    name: "Hack De! India",
    code: "1P07",
    featuring: [Trisha, Riddhi],
    plot: "Trisha, overwhelmed by the surge of technology in her statistics field, starts to study programming and computers, eventually becoming a wanted hacker. Meanwhile, Riddhi gets a job as a make-up salesgirl at a mall."
}


// Riddhi Episodes

const RiddhiPunch: Episode = {
    name: "Dil Yeh Riddhi Hai",
    code: "1P04",
    featuring: [Riddhi],
    plot: "Trisha and Akshay learn that Riddhi is suppresing a lot of emotions. Things become worse when Riddhi punches a roadside romeo. Riddhi becomes a local hero, much to her chagrin. Meanhwile, Parth tries to learn to paint."
}

const RiddhiCrush: Episode = {
    name: "Riddhi Maange More",
    code: "1P09",
    featuring: [Riddhi],
    plot: "Riddhi, the girl who doesn't believe in love, falls in love with the perfect boy. He's great at music, sports and can charm his way through every conversation. Her world is shattered when she realises that her Prince Charming is just like a grown up version of Parth. Meanwhile, Akshay teaches Trisha how to drive."
}


// Parth Episodes

const ParthToilet: Episode = {
    name: "Toilet: Ek Lame Katha",
    code: "1P05",
    featuring: [Parth],
    plot: "When Sanskriti Vidya Mandir aka SVM school's section of toilets is deemed as illegal construction by the municipality, school is closed down. Parth's eutopia is soon shattered when a terrorizing concept is introduced to him — online school, which is all the lectures without all the pranks and sports."
}

const ParthMad: Episode = {
    name: "Parth Parth Dekho",
    code: "1P08",
    featuring: [Parth, MAD],
    plot: "Parth discovers that his aloof neighbour MAD is a Mad Scientist in disguise and persuades MAD to let him be a part of his experiments. MAD hands over a device that lets Parth reset time to an earlier state, only to have unforseen consequences."
}

const ParthChhotaBhai: Episode = {
    name: "Lage Raho Chhota Bhai",
    code: "1P10",
    featuring: [ChhotaBhai, Parth],
    plot: "Chhota Bhai is back in town but this time nobody fears him — including Akshay and Parth. Parth tries to help him by staging himself kidnapped by Chhota Bhai, but things take a turn for the worse when Parth gets kidnapped by someone else, for real."
}

const ParthCricketFight: Episode = {
    name: "Half Cricket",
    code: "1P02",
    featuring: [Parth, Akshay, Bhaskar],
    plot: "Bhaskar Tripathi, the annoying, nose-poking chairman of the society bans the kids from playing cricket. Parth and friends challenge Bhaskar to a cricket match to settle the dispute. Things go awry when Parth discovers that Akshay is playing on Bhaskar's team. Meanwhile, Trisha tries to bond with Riddhi."
}

// Specials

// const ParivaarTalkies: Episode = {
//     name: "Parivaar Talkies",
//     featuring: [Akshay, Trisha, Riddhi, Parth],
//     plot: `The Sanzgiri family narrates three movies about friendship in their own style.
//         1. SSS: Parth and Satish find themselves on opposite sides of their school's law.
//         2. Golay: Thakur Bhaskar hires thieves Akshay and Appu to kill Chhota Gabbar.
//         3. Kuch Nahi Hota Hai: Riddhi sets out to unite her father with his college sweetheart.
//     `
// }

/*
export const SeasonOne: Record<number, Episode> = {
    1: AkshayQuitsJob,
    2: ParthCricketFight,
    3: TrishaRevolt,
    4: RiddhiCrush,
    5: ParthToilet,
    6: AkshayRace,
    7: TrishaHacker,
    8: ParthMad,
    9: RiddhiPunch,
    10: ParthChhotaBhai,
}
*/

export const SeasonOne: Episode[] = [
    AkshayQuitsJob,
    ParthCricketFight,
    TrishaRevolt,
    RiddhiPunch,
    ParthToilet,
    AkshayRace,
    TrishaHacker,
    ParthMad,
    RiddhiCrush,
    ParthChhotaBhai,
    // ParivaarTalkies
]
